import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Select } from '@material-ui/core';
import CadessWarningContainer from '../components/specimenAnalysis/CadessWarningContainer';

export const renderTextField = ({
  className,
  style,
  input,
  label,
  disabled,
  onFocus,
  meta: { touched, error, warning, dirty, active },
  ...custom
}) => (
    <div style={{ position: 'relative' }}>
      <TextField
        label={label}
        className={className}
        errorText={error}
        errorStyle={{
          bottom: '-10px',
          marginBottom: '10px',
        }}
        disabled={disabled}
        underlineStyle={{ borderColor: '#fff', display: 'none' }}
        // style={style}
        {...input}
        {...custom}
      />
      {(touched && dirty && !active)
        && ((warning && <CadessWarningContainer warning={warning} />))}
    </div>
  );

export const renderCheckbox = ({
  input, label, disabled, meta: { touched, error }, ...custom
}) => {
  const classNames = `checkbox ${touched && error ? 'has-error' : ''}`;
  const hasError = {
    outline: '1px solid rgb(244, 67, 54)',
  };

  return (
    <Checkbox

      label={label}
      disabled={disabled}
      checked={!!input.value}
      onCheck={input.onChange}
      className={classNames}
      style={touched && error ? hasError : null}
      {...custom}
    />
  );
};

export const renderRadioButtonGroup = props => {
  const {
    input,
    items,
    className,
    meta: { touched, error, warning, dirty },
    validationTrigger,
    ...custom
  } = props;
  const classNames = className + ((touched || validationTrigger) && error ? ' has-error' : '');

  return (
    <div style={{ position: 'relative' }}>
      <RadioButtonGroup
        {...input}
        valueSelected={input.value}
        // is this necessary?
        //onChange={(event, value) => input.onChange(value)}
        className={classNames}
        {...custom}

      >
        {items.map(item => (
          <RadioButton
            iconStyle={{ fill: '#777' }}
            key={item.value}
            value={item.value}
            label={item.label}
            className="radio"
          />
        ))}
      </RadioButtonGroup>
      {(touched || validationTrigger)
        && ((error && <span className="form-field-error">{error}</span>))}
      {(touched && dirty)
        && (warning && <CadessWarningContainer warning={warning} />)}
    </div>
  );
};

export const renderSelect = props => {
  const { input, options, ...custom } = props;
  const { onChange, onBlur } = input;

  return (
    <Select
      {...input}
      {...custom}
      onChange={value => onChange(value)}
      onBlur={() => onBlur(input.value)}
      options={options}
    />
  );
};
